module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('vbl-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows
    }
  }), _c('br'), _c('vbl-button', {
    on: {
      "click": _vm.clear
    }
  }, [_vm._v("清空")]), _c('br'), _c('br'), _vm._v("\n    \n    自定义单元格\n    "), _c('vbl-table', {
    attrs: {
      "columns": _vm.columns1,
      "rows": _vm.rows
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function(props) {
        return [_c('a', {
          on: {
            "click": function($event) {
              _vm.deleteRow(props.value)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  }), _c('br'), _c('br'), _vm._v("\n    点击选中\n    "), _c('vbl-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "select": _vm.select
    },
    on: {
      "update:select": function($event) {
        _vm.select = $event
      }
    }
  }), _c('br'), _c('p', [_vm._v("选中项：" + _vm._s(_vm.select))]), _c('br'), _c('vbl-button', {
    on: {
      "click": _vm.clearSelect
    }
  }, [_vm._v("取消选中")]), _c('br'), _c('br'), _vm._v("\n    多选\n    "), _c('vbl-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "order": _vm.order,
      "check": _vm.check
    },
    on: {
      "update:check": function($event) {
        _vm.check = $event
      }
    }
  }), _c('br'), _c('p', [_vm._v("选中项：" + _vm._s(_vm.check))]), _c('br'), _c('br'), _vm._v("\n    更多\n    "), _c('vbl-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "order": _vm.order,
      "more": ""
    },
    on: {
      "check": _vm.onChangeCheckbox
    },
    scopedSlots: _vm._u([{
      key: "more",
      fn: function(props) {
        return [_vm._v("\n            " + _vm._s(props.value.name1) + "\n        ")]
      }
    }])
  }), _c('br'), _c('br'), _vm._v("\n    设置宽度\n    "), _c('vbl-table', {
    attrs: {
      "columns": _vm.columns1,
      "rows": _vm.rows,
      "width": "2000"
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function(props) {
        return _c('td', {}, [_c('vbl-popover', {
          attrs: {
            "place": "bottom"
          }
        }, [_vm._v("\n         操作\n        "), _c('div', {
          attrs: {
            "slot": "content"
          },
          slot: "content"
        }, [_c('div', {
          staticStyle: {
            "width": "200px"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              _vm.deleteRow(props.value)
            }
          }
        }, [_vm._v("删除")])]), _c('div', {
          staticStyle: {
            "width": "200px"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              _vm.deleteRow(props.value)
            }
          }
        }, [_vm._v("删除")])]), _c('div', {
          staticStyle: {
            "width": "200px"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              _vm.deleteRow(props.value)
            }
          }
        }, [_vm._v("删除")])]), _c('div', {
          staticStyle: {
            "width": "200px"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              _vm.deleteRow(props.value)
            }
          }
        }, [_vm._v("删除")])]), _c('div', {
          staticStyle: {
            "width": "200px"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              _vm.deleteRow(props.value)
            }
          }
        }, [_vm._v("删除")])]), _c('div', {
          staticStyle: {
            "width": "200px"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              _vm.deleteRow(props.value)
            }
          }
        }, [_vm._v("删除")])])])])], 1)
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3031ff85","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vblTable/example/vblTableExample.vue
// module id = 254
// module chunks = 0